import React from 'react';

import { CompanyType } from 'src/api';
import {
  getRevenueShareInitialValues,
  RevenueShareForm,
  RevenueShareFormValues,
} from 'src/components/revenueShare';
import { useEmployerById, useEmployerParamId } from 'src/hooks/employer';
import { useEmployerRevenueShare } from 'src/hooks/employer/useEmployerRevenueShare';
import { useStripeAccount } from 'src/hooks/stripe';
import {
  PrepareRevenueShareDataActionTypes,
  prepareRevenueShareData,
} from 'src/utils/revenueShare';

export const EmployersDetailsWalletCVStaff: React.FC = () => {
  const employerId = useEmployerParamId();
  const { employer } = useEmployerById(employerId);

  const {
    employerBilling,
    updateEmployerRevenueShare,
    deleteEmployerBilling,
    loading: employerRevenueShareLoading,
  } = useEmployerRevenueShare(employerId);

  const { stripeAccountStatus, loading: stripeAccountLoading } = useStripeAccount(
    employer?.stripeAccountId,
  );

  const handleSubmit = React.useCallback(
    async (formValues: RevenueShareFormValues) => {
      try {
        const { revenueShareEnabled, ...formData } = formValues;

        if (revenueShareEnabled) {
          const employerBillingAction = employerBilling?.revenueShareSetting
            ? PrepareRevenueShareDataActionTypes.Update
            : PrepareRevenueShareDataActionTypes.Create;

          const dataToSubmit = prepareRevenueShareData(
            employerBillingAction,
            CompanyType.Employer,
            formData,
          );
          await updateEmployerRevenueShare(dataToSubmit);
        } else {
          await deleteEmployerBilling({ id: employerBilling?.revenueShareSetting?.id });
        }
      } catch (error) {
        console.error(error);
      }
    },
    [deleteEmployerBilling, employerBilling?.revenueShareSetting, updateEmployerRevenueShare],
  );

  return (
    <RevenueShareForm
      companyType={CompanyType.Employer}
      stripeAccountStatus={stripeAccountStatus}
      initialValues={getRevenueShareInitialValues(employerBilling)}
      handleSubmit={handleSubmit}
      loading={stripeAccountLoading || employerRevenueShareLoading}
    />
  );
};
